import { tryAxios } from '@/api/common/auth'
import { urlPrefix } from '@/configs/api'
import { UnitAreaData } from '@/api/heritageUnit/unitBase'
import { DynamicAttachData } from '@/api/common/attach'

const apiUrl = `${urlPrefix}/EighthHeritageUnit`
//#region EighthHeritage
const GetList = `${apiUrl}`
const GetListToEntrust = `${apiUrl}/entrustList`
const Get = (id: number) => `${apiUrl}/${id}`
const View = (id: number) => `${apiUrl}/view/${id}`
const Post = `${apiUrl}`
const Put = (id: number) => `${apiUrl}/${id}`
const Delete = (id: number) => `${apiUrl}/${id}`
const DeleteUnitFile = (id: number, attachId: number) => `${apiUrl}/DelFile?id=${id}&attachId=${attachId}`

const GetStatusList = `${apiUrl}/GetStatus`
const GetReviewStatusList = `${apiUrl}/GetReviewStatus`
const PostBack = `${apiUrl}/back`
const PostAccept = (id: number) => `${apiUrl}/accept/${id}`

const ExportWord = (id: number) => `${apiUrl}/exportWord/${id}?h_np`

const GetEntrustToExport = `${apiUrl}/entrustToExport`
const ExportBatch = (batchCode: string) => `${apiUrl}/exportBatch/${batchCode}?h_np`
//#endregion
///文保单位列表实体，另外加增删改权限控制
export const emptyBack: EighthBackData = {
    Id: 0,
    UnitId: 0,
    UnitCode: '',
    UnitName: '',
    Comments: ''
}
export const emptyEighthCompose: EighthComposeData = {
    Id: 0,
    UnitInfoId: 0,
    PublishClassifyId: 0,
    ClassifyName: '',

    ComposeName: '',
    AgeName: '',
    Area: '',
    Comments: ''
}
export const emptyEighthUnit: EighthUnitData = {
    DynamicAttachType: 0,
    DynamicAttachs: [],
    IsDraft: false,
    AreaList: [],
    ComposeList: [],
    CityId: 0,
    CityName: '',
    CountyId: 0,
    CountyName: '',
    AreaTypeName: '',
    LevelName: '',
    ClassifyName: '',
    SubClassifyName: '',
    BatchName: '',
    StatisticAgeName: '',

    Id: 0,
    Category: 0,
    LevelId: 0,
    HeritageCode: '',
    HeritageName: '',
    HeritageShortName: '',
    PublishClassifyId: 0,
    SubClassifyId: 0,
    SubClassifyOther: '',
    BatchId: 0,
    PublishAge: '',
    StatisticAgeId: 0,
    PublishAddress: '',
    DetailAddress: '',
    BuiltArea: 0,
    FloorArea: 0,
    AreaType: 0,
    AreaCode: '',
    AreaName: '',

    Longitude: 0,
    Latitude: 0,
    SeaHeight: 0,
    Location: '',
    PointExplain: '',

    OwnerShip: '',
    UsageName: '',
    Administration: '',
    Usage: '',
    ApplyUnitName: '',
    ApplyDate: new Date(),

    StateSummary: '',
    Description: '',
    Background: '',
    ProtectBackground: '',
    Valuation: '',
    Assessment: '',
    CompareAnalysis: '',
    FourTasks: '',
    Security: '',

    RelatedResearch: '',
    RelatedWork: '',
    ComingWork: '',

    InformantName: '',
    InformantUnit: '',
    InformantTel: '',
    InformantEmail: '',
    Status: 0,

    NewUserId: 0,
    NewDate: new Date(),
    UpdateUserId: 0,
    UpdateDate: new Date(),

    LngDegree: 0,
    LngSecond: 0,
    LngMinute: 0,

    LatDegree: 0,
    LatSecond: 0,
    LatMinute: 0
}
export interface EighthUnitListData {
    [key: string]: any
    UnitId: number
    UnitCode: string
    UnitName: string
    PublishName: string
    Category: number
    CategoryName: string
    LevelId: number
    LevelName: string
    BatchId: number
    BatchName: string
    ClassifyId: number
    ClassifyName: string
    SubClassifyId: number
    SubClassifyName: string
    StatisticAgeId: number
    StatisticAgeName: string
    PublishAge: string
    AreaType: number
    AreaTypeName: string
    CityId: number
    CountyId: number
    CityName: string
    CountyName: string
    AreaCode: string
    AreaName: string
    Status: number
    NewUserId: number
    UpdateDate: Date

    DoEdit: boolean
    DoDel: boolean
    DoBack: boolean
    DoExport: boolean
    DoAudit: boolean
}
//待委托评审列表
export interface EighthUnitEntrustListData {
    [key: string]: any
    UnitId: number
    UnitCode: string
    UnitName: string
    Category: number
    CategoryName: string
    LevelId: number
    LevelName: string
    BatchId: number
    BatchName: string
    ClassifyId: number
    ClassifyName: string
    SubClassifyId: number
    SubClassifyName: string
    StatisticAgeId: number
    StatisticAgeName: string
    PublishAge: string
    AreaType: number
    AreaTypeName: string
    CityId: number
    CountyId: number
    CityName: string
    CountyName: string
    AreaCode: string
    AreaName: string
    Status: number
    UpdateDate: Date

    ExpertAllocateId: number
    AllocateCount: number
    CompleteCount: number
    PendingCount: number
    CanAllocate: boolean

    DoEdit: boolean
    DoDel: boolean
    DoBack: boolean
    DoExport: boolean
    DoAudit: boolean
    DoAllocate: boolean//委托评审，分配专家
}
export interface EighthBackData {
    [key: string]: any
    Id: number
    UnitId: number
    UnitName: string
    Comments: string
}
export interface EighthComposeData {
    [key: string]: any
    Id: number
    UnitInfoId: number
    ComposeName: string
    AgeName: string
    Area: string
    Comments: string

    PublishClassifyId: number
    ClassifyName: string
}
export interface EighthUnitData {
    [key: string]: any
    DynamicAttachType: number
    DynamicAttachs: DynamicAttachData[]
    IsDraft: boolean
    AreaList: UnitAreaData[]
    ComposeList: EighthComposeData[]
    CityId: number
    CityName: string
    CountyId: number
    CountyName: string
    AreaTypeName: string
    LevelName: string
    ClassifyName: string
    SubClassifyName: string
    BatchName: string
    StatisticAgeName: string

    Id: number
    Category: number
    LevelId: number
    HeritageCode: string
    HeritageName: string
    HeritageShortName: string
    PublishClassifyId: number
    SubClassifyId: number
    SubClassifyOther: string
    BatchId: number
    PublishAge: string
    StatisticAgeId: number
    PublishAddress: string
    DetailAddress: string
    BuiltArea: number
    FloorArea: number
    AreaType: number
    AreaCode: string
    AreaName: string

    Longitude: number
    Latitude: number
    SeaHeight: number
    Location: string
    PointExplain: string

    OwnerShip: string
    UsageName: string
    Administration: string
    Usage: string
    ApplyUnitName: string
    ApplyDate: Date

    StateSummary: string
    Description: string
    Background: string
    ProtectBackground: string
    Valuation: string
    Assessment: string
    CompareAnalysis: string
    FourTasks: string
    Security: string

    RelatedResearch: string
    RelatedWork: string
    ComingWork: string

    InformantName: string
    InformantUnit: string
    InformantTel: string
    InformantEmail: string
    Status: number

    NewUserId: number
    NewDate: Date
    UpdateUserId: number
    UpdateDate: Date

    LngDegree: number
    LngSecond: number
    LngMinute: number

    LatDegree: number
    LatSecond: number
    LatMinute: number
}
export const getStatusList = (firstType: number) => {
    return tryAxios({
        method: 'get',
        url: GetStatusList,
        params: { type: firstType }
    })
}
export const getReviewStatusList = (firstType: number) => {
    return tryAxios({
        method: 'get',
        url: GetReviewStatusList,
        params: { type: firstType }
    })
}
export const getList = (param: any) => {
    return tryAxios({
        method: 'get',
        url: GetList,
        params: param
    })
}
export const getListToEntrust = (param: any) => {
    return tryAxios({
        method: 'get',
        url: GetListToEntrust,
        params: param
    })
}
export const getInfo = (id: number) => {
    return tryAxios({
        method: 'get',
        url: Get(id),
    })
}
export const viewInfo = (id: number) => {
    return tryAxios({
        method: 'get',
        url: View(id),
    })
}
export const exportWord = (id: number) => {
    return tryAxios({
        method: 'get',
        url: ExportWord(id),
    })
}
export const postBack = (form: EighthBackData) => {
    return tryAxios({
        method: 'post',
        url: PostBack,
        data: form
    })
}
export const postAccept = (id: number) => {
    return tryAxios({
        method: 'post',
        url: PostAccept(id),
    })
}
export const postData = (form: EighthUnitData) => {
    return tryAxios({
        method: 'post',
        url: Post,
        data: form
    })
}
export const putData = (id: number, form: EighthUnitData) => {
    return tryAxios({
        method: 'put',
        url: Put(id),
        data: form
    })
}
export const removeData = (id: number) => {
    return tryAxios({
        method: 'delete',
        url: Delete(id)
    })
}
export const removeEighthUnitFile = (id: number, attachId: number) => {
    return tryAxios({
        method: 'post',
        url: DeleteUnitFile(id, attachId)
    })
}
export const getEntrustToExport = (param: any) => {
    return tryAxios({
        method: 'get',
        url: GetEntrustToExport,
        params: param
    })
}
export const exportBatch = (batchCode: string) => {
    return tryAxios({
        method: 'get',
        url: ExportBatch(batchCode),
    })
}